import type { RouteRecordRaw } from 'vue-router'
import { RoutePath } from '~/enums/path'

export const staticRoutes = [
  {
    path: '/',
    redirect: RoutePath.Base,
  },
] as RouteRecordRaw[]
